import {forwardRef, Ref} from 'react';
import './flat-starts-at-date.scss';
import {MobileDatePickerProps} from '@mui/x-date-pickers';
import {FlatSelectDate} from '../flat-select-date/flat-select-date';

interface FlatStartsAtDateProps extends MobileDatePickerProps<Date> {
  id?: string;
  label?: string;
  required?: boolean;
  errors?: string;
  readonly?: boolean;
  allowClear?: boolean;
  noUtc?: boolean;
}

export const FlatStartsAtDate = forwardRef(
  (
    {
      label,
      required,
      disabled,
      readonly,
      errors,
      allowClear,
      disableFuture,
      disablePast = true,
      ...rest
    }: FlatStartsAtDateProps,
    ref: Ref<HTMLInputElement>
  ) => {
    return (
      <FlatSelectDate
        label={label}
        required={required}
        disabled={disabled}
        readonly={readonly}
        errors={errors}
        allowClear={allowClear}
        disableFuture={disableFuture}
        disablePast={disablePast}
        {...rest}
      />
    );
  }
);
